<template>
  <div class="w-full flex flex-col gap-2">
    <label
      class="text-[#121212] font-semibold text-[16px] leading-[24px]"
      style="font-family: 'Open Sans'; font-weight: 600"
    >
      {{ label }} <span class="text-red-500">*</span>
    </label>
    <div
      class="w-full h-[46px] border border-[#CCCCCC] rounded-[8px] flex items-center px-3"
      :class="{ 'border-red-500': v$.email.$error }"
    >
      <input
        type="email"
        :value="modelValue"
        @input="updateValue($event)"
        class="w-full h-full text-[#1c1c1c] text-[14px] leading-[22.4px] outline-none bg-transparent cursor-text"
        style="font-family: 'Open Sans'; font-weight: 400"
        :placeholder="placeholder"
        readonly
      />
    </div>
    <p v-if="v$.email.$error" class="text-red-500 text-[14px]">
      {{ v$.email.$errors[0].$message }}
    </p>
  </div>
</template>
  
<script setup>
import { computed } from "vue";
import useVuelidate from "@vuelidate/core";
import {
  required,
  email as emailValidator,
  helpers,
} from "@vuelidate/validators";

const props = defineProps({
  label: { type: String, default: "Email" },
  modelValue: String,
  placeholder: { type: String, default: "Enter your email address" },
});

const emit = defineEmits(["update:modelValue"]);

const rules = computed(() => ({
  email: {
    required: helpers.withMessage("Email is required", required),
    email: helpers.withMessage("Invalid email format", emailValidator),
  },
}));

const v$ = useVuelidate(rules, { email: computed(() => props.modelValue) });

const updateValue = (event) => {
  emit("update:modelValue", event.target.value);
  v$.value.email.$touch();
};
</script>
  